import { render, staticRenderFns } from "./AccountsReceivable.vue?vue&type=template&id=64f727f0&scoped=true"
import script from "./AccountsReceivable.vue?vue&type=script&lang=js"
export * from "./AccountsReceivable.vue?vue&type=script&lang=js"
import style0 from "./AccountsReceivable.vue?vue&type=style&index=0&id=64f727f0&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f727f0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Karl\\Code\\customs_clearance\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64f727f0')) {
      api.createRecord('64f727f0', component.options)
    } else {
      api.reload('64f727f0', component.options)
    }
    module.hot.accept("./AccountsReceivable.vue?vue&type=template&id=64f727f0&scoped=true", function () {
      api.rerender('64f727f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/const/AccountsReceivable.vue"
export default component.exports